import { call, delay, select } from 'redux-saga/effects';
import axios from 'axios';

// Selectors
import type { Saga } from 'redux-saga';
import { idTokenSelector } from '../services/auth/selectors';

// Types

export default function* axiosRetry(config): Saga<void> {
    // Select ID Token
    const idToken = yield select(idTokenSelector);

    for (let i = 0; i < 5; i += 1) {
        try {
            const response = yield call(axios, {
                ...config,
                headers: {
                    ...(config && config.headers ? config.headers : {}),
                    Authorization: idToken
                }
            });
            return response;
        } catch (error) {
            if (i < 4) {
                yield delay(2000);
            } else {
                throw error;
            }
        }
    }
    return undefined;
}
